import React, { useRef } from 'react';
import { motion, useReducedMotion, useScroll, useTransform } from 'framer-motion';
import { images } from '../data/images';
import { Reveal } from './Reveal';
export function Story() {
  const ref = useRef<HTMLDivElement>(null);
  const reduce = useReducedMotion();
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['-8%', '8%']);
  return <section id="verhaal" className="bg-linen" data-id="element-120" data-mp="ugsx4rpx2521">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-24 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:py-32" data-id="element-121" data-mp="zem7zy25zn8n">
        <div ref={ref} className="overflow-hidden rounded-[2rem] lg:col-span-5" data-id="element-122" data-mp="14bulhlcdb33k">
          <motion.img src={images.story} alt="Handen van twee generaties mengen henna in een terracotta schaal" style={{
          y,
          scale: 1.18
        }} className="aspect-[4/5] w-full object-cover" data-id="element-123" data-mp="18faiwjw9h7hb" />
        </div>
        <div className="flex flex-col justify-center lg:col-span-7 lg:pl-6" data-id="element-124" data-mp="1921rn6o7urhh">
          <Reveal data-id="element-125" data-mp="191a4mk8oq22t">
            <h2 className="font-display text-5xl font-medium leading-[0.95] text-ink sm:text-7xl" data-id="element-126" data-mp="142yxih9ry5oa">
              Het verhaal <span className="italic text-clay" data-id="element-127" data-mp="z3lyyz9jja5v">van Amira</span>
            </h2>
          </Reveal>
          <Reveal delay={0.05} className="mt-10 grid gap-6 text-base leading-relaxed text-muted sm:grid-cols-2 sm:gap-10" data-id="element-128" data-mp="v2k9391ikagk">
            <p data-id="element-129" data-mp="q3h6rwcx4ica">
              Amira groeide op in Aït Baha, een kleine plaats tussen de heuvels van de Anti-Atlas, ten zuiden van Agadir.
              Cosmetica bestond daar niet uit chemische producten uit kastjes, maar uit de meest natuurlijke producten.
            </p>
            <p data-id="element-130" data-mp="bekx5uv7qx9k">
              Bij haar oma zag ze henna, flesjes arganolie en gedroogde planten. Ze hielp met mengen, ging mee naar de souk,
              observeerde en stelde vragen — en zo begreep ze steeds meer.
            </p>
            <p className="sm:col-span-2" data-id="element-131" data-mp="2eo4li5pde98">
              Later zag ze diezelfde ingrediënten terug in hedendaagse beautyproducten, nu verpakt in grote verhalen en grote
              beloftes. Dus besloot Amira terug te gaan naar de basis: de kennis van haar oma.
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-132" data-mp="3ey8xpu2hho60">
            <blockquote className="mt-12 rounded-[2rem] bg-ink p-8 text-sand sm:p-10" data-id="element-133" data-mp="3ez1wa7rah7d2">
              <p className="font-display text-3xl italic leading-snug sm:text-4xl" data-id="element-134" data-mp="3jwtybulne9uz">
                “Een product hoef je niet mooier te maken dan het is. Je moet weten wat het is, wat het doet en hoe je het
                gebruikt.”
              </p>
              <footer className="mt-5 text-sm text-sand/60" data-id="element-135" data-mp="1qyxmz23404a">Deze visie is de basis van AMIRA.</footer>
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>;
}